module.exports = __webpack_public_path__ + "static/media/l-md11.fc463617.png";